























import { Component, Prop, Vue } from 'vue-property-decorator';
import FormRow from '@/components/common/forms/FormRow.vue';
import FormInput from '@/components/common/forms/FormInput.vue';
import { LoginDto, SendResetPasswordModel } from 'admiral-core';
import FormInputPassword from '@/components/common/forms/FormInputPassword.vue';
import FormError from '@/components/common/forms/FormError.vue';

@Component({
  components: { FormError, FormInputPassword, FormInput, FormRow },
})
export default class ForgotPasswordForm extends Vue {
  @Prop({ required: true, type: Object })
  readonly value!: SendResetPasswordModel;

  @Prop({ required: true, type: Object })
  readonly errors!: SendResetPasswordModel;

  onInput(key: keyof LoginDto, value: any) {
    this.$emit('input', { ...this.value, [key]: value });
  }

  onErrorReset(key: keyof LoginDto) {
    this.$emit('resetError', key);
  }
}
